import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import client from '../api/client';
import Spinner from '../components/ui/Spinner';
import OrderStatusBadge from '../components/order/OrderStatusBadge';
import { formatPrice } from '../utils/money';

// User order history — GET /api/order -> { items, page, limit, total, pages }.
export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    client
      .get('/order', { params: { limit: 50 } })
      .then(({ data }) => {
        if (active) setOrders(data?.items || []);
      })
      .catch(() => {
        if (active) setOrders([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  if (loading) {
    return <div className="ss-container ss-state"><Spinner label="Loading orders" size={32} /></div>;
  }

  return (
    <section className="ss-container" style={{ paddingBlock: 'var(--ss-space-6)' }}>
      <h1>Your orders</h1>

      {orders.length === 0 ? (
        <div className="ss-state">
          <h2>No orders yet</h2>
          <p style={{ marginTop: 'var(--ss-space-4)' }}>
            <Link className="ss-btn ss-btn--primary" to="/products">Start shopping</Link>
          </p>
        </div>
      ) : (
        <div style={{ marginTop: 'var(--ss-space-5)' }}>
          {orders.map((o) => (
            <div key={o._id || o.orderNumber} className="ss-order-row">
              <div>
                <div className="ss-order-row__num">
                  <Link to={`/orders/${o.orderNumber}`}>{o.orderNumber}</Link>
                </div>
                <div className="ss-order-row__meta">
                  {(o.items || []).reduce((n, i) => n + i.quantity, 0)} item(s)
                </div>
              </div>
              <div className="ss-order-row__badges">
                <OrderStatusBadge status={o.status} />
                <OrderStatusBadge status={o.paymentStatus} />
              </div>
              <div className="ss-order-row__price">
                <div style={{ fontWeight: 700 }}>{formatPrice(o.total)}</div>
                {o.balanceDue > 0 && (
                  <div className="ss-order-row__balance">Balance due: {formatPrice(o.balanceDue)}</div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
